<script setup lang="ts">
import {computed} from "vue"

const props = defineProps<{ href?: string }>()

const resolvedHref = computed(() => props.href ?? window.location.origin + window.location.pathname)
</script>

<template>
  <a :href="resolvedHref" class="self-link"><slot /></a>
</template>

<style scoped>
.self-link,
.self-link:link,
.self-link:visited {
  color: inherit !important;
  text-decoration: none;
}
.self-link:hover {
  text-decoration: underline;
}
</style>
